import React from 'react';
import { Box, Card } from '@mui/material';
import SkeletonLoader from './index';

const PerfilSkeleton = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "white",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        fontFamily: "system-ui, -apple-system, sans-serif"
      }}
    >
      {/* Header skeleton */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          maxWidth: '400px',
          marginBottom: '20px',
          position: 'relative'
        }}
      >
        <SkeletonLoader
          variant="text"
          width={80}
          height={30}
          sx={{ marginBottom: 0 }}
        />
        <SkeletonLoader
          variant="circular"
          width={32}
          height={32}
          sx={{ position: 'absolute', right: 0 }}
        />
      </Box>

      {/* Foto de perfil skeleton */}
      <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: '2px' }}>
        <Box sx={{ position: 'relative' }}>
          <SkeletonLoader
            variant="circular"
            width={120}
            height={120}
            sx={{ 
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
              border: '4px solid white'
            }}
          />
    
        </Box>
      </Box>

      {/* Saludo skeleton */}
      <Box sx={{ textAlign: 'center', marginBottom: '24px', marginTop: '2px' }}>
        <SkeletonLoader
          variant="text"
          width={200}
          height={32}
          sx={{ marginBottom: '10px' }}
        />
        
        {/* Botones de estado skeleton */}
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: '16px', marginBottom: '12px' }}>
          <SkeletonLoader
            variant="rounded"
            width={80}
            height={32}
            sx={{ borderRadius: '20px' }}
          />
          <SkeletonLoader
            variant="rounded"
            width={80}
            height={32}
            sx={{ borderRadius: '20px' }}
          />
        </Box>
      </Box>

      {/* Card del menú skeleton */}
      <Card sx={{ 
        width: '100%', 
        maxWidth: '400px',
        borderRadius: '20px', 
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)', 
        backgroundColor: 'white',
        overflow: 'hidden',
        marginTop: '8px'
      }}>
        <Box sx={{ padding: '10px 20px' }}>
          {/* Mi descripción skeleton */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '15px 0',
              borderBottom: '1px solid #f0f0f0'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <SkeletonLoader variant="circular" width={24} height={24} />
              <SkeletonLoader variant="text" width={120} height={20} />
            </Box>
            <SkeletonLoader variant="circular" width={16} height={16} />
          </Box>

          {/* Cuenta bancaria skeleton */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '15px 0',
              borderBottom: '1px solid #f0f0f0'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <SkeletonLoader variant="circular" width={24} height={24} />
              <SkeletonLoader variant="text" width={140} height={20} />
            </Box>
            <SkeletonLoader variant="circular" width={16} height={16} />
          </Box>

          {/* Mensajes skeleton */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '15px 0',
              borderBottom: '1px solid #f0f0f0'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <SkeletonLoader variant="circular" width={24} height={24} />
              <SkeletonLoader variant="text" width={100} height={20} />
            </Box>
            <SkeletonLoader variant="circular" width={16} height={16} />
          </Box>

          {/* Ajustes skeleton */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '15px 0',
              borderBottom: '1px solid #f0f0f0'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <SkeletonLoader variant="circular" width={24} height={24} />
              <SkeletonLoader variant="text" width={80} height={20} />
            </Box>
            <SkeletonLoader variant="circular" width={16} height={16} />
          </Box>

          {/* Ayuda skeleton */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '15px 0'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <SkeletonLoader variant="circular" width={24} height={24} />
              <SkeletonLoader variant="text" width={70} height={20} />
            </Box>
            <SkeletonLoader variant="circular" width={16} height={16} />
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default PerfilSkeleton;
